import * as IoC from 'inversify';
import { StateSerializationPluginSymbol } from '@/app/state-serialization/api';
import * as Serialization from '../serialization'
import { ExamSuspendDataStore } from '../common';

export const examCommonTrackingModule = new IoC.ContainerModule((bind) => {
  bind(ExamSuspendDataStore).toSelf().inSingletonScope()
  bind(StateSerializationPluginSymbol).to(Serialization.ExamStateProtobufSerializer)
})
